import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getAllProcessErrors(queryString) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/process-errors?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process errors"
                    });
                }
            });
    },
    removeProcessError(errorId) {
        return axios.delete(constants.BASE_URL + "/process-errors/" + errorId, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
}
